import {ApiResponse} from "../models/ApiResponse";
import MainBackendAxios from "../utils/MainBackendAxios";
import {FunctionsHelper} from "../utils/FunctionsHelper";
import {OperationTag} from "../models/OperationTag";

export const OperationTagService = {
    getAll: async (): Promise<ApiResponse<OperationTag[]>> => {
        try {
            const response = await MainBackendAxios.get(`/operation-tag/get-all`);

            return {
                success: true,
                status: response.status,
                data: response?.data?.data,
            };
        } catch (err: any) {
            return FunctionsHelper.getErrorFormat(err);
        }
    },
};
